import React, { useState, useEffect, useRef } from 'react';
import env from 'react-dotenv';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";
import ReCAPTCHA from 'react-google-recaptcha';

// Api methods
import { loginUser } from '../../api/authentication/register';

// Components
import Logo from '../../components/Logo';
import OtpModal from '../RegistrationPage/OtpModal';

// Tracking
import { setTrackingUserId } from '../../tracking/trackPage';

const LoginPage = () => {
    const {
        register,
        handleSubmit,
        control,
        setError,
        formState: {
            isSubmitting, isDirty, isValid, errors, isSubmitSuccessful
        }
    } = useForm();
    const [responseData, setResponseData] = useState();
    const navigate = useNavigate();
    const recaptchaRef = useRef();

    const onSubmit = async data => {
        try {
            const token = await recaptchaRef.current.executeAsync();
            if (!token) return;
            const response = await loginUser(data.email, data.password, token);
            setResponseData(response?.data);
        } catch (e) {
            recaptchaRef.current.reset();
            setError("root.serverError", {type: "400"});
        }
    };

    const handleCloseOtpModal = () => {
        setResponseData(undefined);
    }

    useEffect(() => {
        if (responseData?.statusCode === 1 || responseData?.statusCode === 2) {
            localStorage.setItem('auth', responseData?.token);
        }

        if (responseData?.statusCode === 1) {
            setTrackingUserId();
            // Everyone lands on their list of events
            navigate('/dashboard');
        }
    }, [navigate, responseData?.statusCode, responseData?.token])


    return <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <div className="flex items-center justify-center text-black-600"><Logo size="md" /></div>
            <h3 className="mt-10 text-center text-xl font-semibold leading-9 tracking-tight text-gray-700">Hesaba giriş səhifəsi</h3>
        </div>
    
        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form className="space-y-3" onSubmit={handleSubmit(onSubmit)}>
            <div>
                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">E-poçt</label>
                <div className="mt-1">
                    <Controller
                        control={control}
                        name="email"
                        render = {()=> (
                            <input
                                {...register("email", {required: true, pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/})}
                                id="email"
                                name="email"
                                type="email"
                                placeholder="E-poçt daxil edin"
                                required
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                            />
                        )}
                    />
                </div>
            </div>
            <div>
                <div className="flex items-center justify-between">
                    <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">Şifrə</label>
                    <div className="text-sm">
                        {/* <Link to={FORGOT_PASSWORD} className="font-semibold text-black-600 hover:text-black-500">Şifrəni unutdun?</Link> */}
                    </div>
                </div>
                <div className="mt-1">
                    <input
                        {...register("password", {required: true, minLength: 8})}
                        id="password"
                        name="password"
                        type="password"
                        minLength="8"
                        required
                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6" />
                </div>
            </div>

            <div className="pt-2">
                {isSubmitSuccessful && responseData?.statusCode === 2 && <OtpModal onClose={handleCloseOtpModal} />}   
                {errors?.root?.serverError && <div className="text-red-600 mb-2">Daxil edilmiş qeydiyyat nişanı və şifrə ilə hesab tapılmadı.</div>}
                <ReCAPTCHA ref={recaptchaRef} sitekey={env.GOOGLE_RECAPTCHA_SITE_KEY} size="invisible" hl="az" />
                <button
                    disabled={!isDirty || !isValid || isSubmitting}
                    className="flex w-full justify-center rounded-md bg-blue-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 disabled:bg-gray-400"
                >
                    {isSubmitting ? <svg aria-hidden="true" role="status" className="inline w-4 h-4 me-3 my-auto text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                    </svg> : null}
                    {isSubmitting ? 'Gözləyin...' : 'Daxil ol'}
                </button>
            </div>
        </form>
    
        </div>
    </div>
}

export default LoginPage;